import { IAppState } from '../../common/state';

export function selectNewbuildingBrokerConsultantBannerUrl(state: IAppState) {
  return state.featureToggle.newbuildingBrokerConsultantBannerUrl;
}
